import { render, staticRenderFns } from "./DashboardContent.vue?vue&type=template&id=1dff5445&"
import script from "./DashboardContent.vue?vue&type=script&lang=js&"
export * from "./DashboardContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports